import { render, staticRenderFns } from "./aiTrade.vue?vue&type=template&id=65af823a&scoped=true"
import script from "./aiTrade.vue?vue&type=script&lang=js"
export * from "./aiTrade.vue?vue&type=script&lang=js"
import style0 from "./aiTrade.vue?vue&type=style&index=0&id=65af823a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af823a",
  null
  
)

export default component.exports